import './sections.scss';
function SectionItem(props) {

    console.log()
    let SectionList = props.sectionInfo.map ((cart, idx) =>
    {    
        // let Section = cart.text.map ((i, idx)=> {
        //       return (
        //            <p key={idx}> {i.section}</p>
        //       )
        //  })
        return ( 
            <div className={"section " + (cart.className)} key={idx}>
                <div className="section_desc">
                    <div className="title-desc">
                        <div className="title">
                            {cart.title}
                        </div>
                        <div className="text">
                            {cart.text}
                        </div>
                    </div>
                    <div className="wrap-price">
                        <div className="wrap-price-color">
                            <div className="price">
                                <div className="price-old">
                                {cart.priceOld}
                                </div>
                                <div className="price-new">
                                {cart.priceNew}
                                </div>
                            </div>
                            <div className="color">
                                <img  className="pic" src= "/img/color1.png" alt= "PULT.RU" title="Черный лак"></img>
                                <img  className="pic" src= "/img/color2.png" alt= "PULT.RU" title="Черный дуб"></img>
                                <img  className="pic" src= "/img/color3.png" alt= "PULT.RU" title="Орех"></img>
                                <img  className="pic" src= "/img/color4.png" alt= "PULT.RU" title="Белый"></img>
                            </div>
                        </div>
                        
                        <div className="wrap-price-btn">
                            <div className="btn-buy">
                                <a className="link-buy" href = {cart.href}>
                                    Купить
                                    <svg width="27" height="31" viewBox="0 0 27 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3.67286 10.8168C3.76755 9.78754 4.63087 9 5.66445 9H21.3356C22.3691 9 23.2325 9.78754 23.3271 10.8168L24.7991 26.8168C24.907 27.9888 23.9845 29 22.8076 29H4.19245C3.01552 29 2.09304 27.9887 2.20086 26.8168L3.67286 10.8168Z" stroke="white" strokeWidth="3"/>
                                        <path d="M19 9C19 9 16.5376 9 13.5 9C10.4624 9 8 9 8 9C8 5.13401 10.4624 2 13.5 2C16.5376 2 19 5.13401 19 9Z" stroke="white" strokeWidth="3"/>
                                    </svg>
                                </a>
                            </div>
                            <a className="review"  href = "https://www.youtube.com/watch?v=3DzH5ii2tsY">
                                Смотреть обзор
                            </a>
                        </div>
                    </div>
        
                </div>
                <div className="section_pic">
                    <img  className="pic" src= {cart.src} alt= {cart.alt} ></img>
                </div>
            </div>
        )
    });

return (
    <div>{SectionList}</div>
)}
export default SectionItem;